import { motion } from "framer-motion";
import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import {
  Video,
  MessageCircle,
  PhoneCall,
  BookUser,
  Mail,
  Locate,
} from "lucide-react";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Accordion from "../../components/Accordion";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/b5a2d98e-28c1-4afd-adff-b1f51bdaba9f" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_gallery2.field_media_image,field_gallery3.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image,field_imagen1.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_gallery1,field_gallery2,field_gallery3,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen14,field_imagen15,field_imagen1" +
  "&fields[media--image]=field_media_image";

function Contacto() {
  const processContent = (html) => {
    if (!html) return "";
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://portales.utpl.edu.ec/beportales/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };

  const DataDisplay = ({ data }) => {
    const centros = [
      data?.bloque9,
      data?.bloque10,
      data?.bloque11,
      data?.bloque12,
      data?.bloque13,
      data?.bloque14,
    ].filter(Boolean);

    return (
      <div>
        <BlockImageCabecera
          src={data?.imagen_portada}
          title={
            <div
              dangerouslySetInnerHTML={{
                __html: processContent(data?.texto_portada),
              }}
            />
          }
        />

        <div
          className="text-center max-w-4xl px-0 sm:px-6 m-auto py-12"
          dangerouslySetInnerHTML={{
            __html: processContent(data?.bloque1),
          }}
        />

        <section className="px-6 max-w-7xl mx-auto pb-12 link-with-arrow-1">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {/* 1. Zoom */}
            <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
              <div className="p-3 mb-3 rounded-full bg-blue-50 text-blue-600">
                <Video className="w-6 h-6" />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque2),
                }}
              />
            </div>

            {/* 2. WhatsApp */}
            <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
              <div className="p-3 mb-3 rounded-full bg-emerald-50 text-emerald-600">
                <MessageCircle className="w-6 h-6" />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque3),
                }}
              />
            </div>

            {/* 3. Línea Gratuita */}
            <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
              <div className="p-3 mb-3 rounded-full bg-indigo-50 text-indigo-600">
                <PhoneCall className="w-6 h-6" />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque4),
                }}
              />
            </div>

            {/* 4. Directorio Institucional */}
            <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
              <div className="p-3 mb-3 rounded-full bg-amber-50 text-amber-600">
                <BookUser className="w-6 h-6" />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque5),
                }}
              />
            </div>

            {/* 5. Correo Institucional */}
            <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
              <div className="p-3 mb-3 rounded-full bg-rose-50 text-rose-600">
                <Mail className="w-6 h-6" />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque6),
                }}
              />
            </div>

            {/* 6. Centros */}
            <div className="flex flex-col items-center text-center p-4 rounded-xl border border-slate-200/80 bg-white shadow-sm hover:shadow-md transition-all">
              <div className="p-3 mb-3 rounded-full bg-sky-50 text-sky-600">
                <Locate className="w-6 h-6" />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque7),
                }}
              />
            </div>
          </div>
        </section>

        <section className="py-24 bg-slate-50">
          <div className="px-0 sm:px-6 max-w-6xl mx-auto">
            <div
              className="max-w-3xl m-auto text-center button-a [&_a]:m-auto mb-10"
              dangerouslySetInnerHTML={{
                __html: processContent(data?.bloque8),
              }}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {centros.map((centro, index) => (
                <motion.article
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.15 }}
                  transition={{ duration: 0.45, delay: index * 0.08 }}
                  className="group overflow-hidden rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-lg transition-shadow duration-300"
                >
                  <div
                    className=" p-4
                      centro-internacional
                      [&_img]:w-full
                      [&_img]:h-56
                      [&_img]:object-cover
                      [&_img]:transition-transform
                      [&_img]:duration-500
                      group-hover:[&_img]:scale-105
                      [&_h2]:text-xl
                      [&_h2]:font-bold
                      [&_h2]:text-[#004270]
                      [&_h2]:leading-snug
                      [&_h2]:mb-3
                      [&_p]:text-sm
                      [&_p]:text-gray-600
                      [&_p]:leading-relaxed
                      [&_p]:flex
                      [&_p]:items-start
                      [&_p]:gap-2
                      [&_p]:mb-0
                      [&_p]:[overflow-wrap:anywhere]
                    "
                  >
                    <div className="overflow-hidden">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: processContent(centro),
                        }}
                      />
                    </div>
                  </div>
                </motion.article>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-5xl m-auto px-0 sm:px-6">
            <div className="flex items-end bg-slate-50">
              <div className="w-[350px]">
                <img src={data.imagen15}></img>
              </div>
              <div
                className="img-contacto text-center [&_img]:w-10 [&_a]:inline-flex [&_a]:grayscale [&_img]:opacity-70 mb-6"
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque15),
                }}
              />
            </div>
          </div>

          <div className="max-w-5xl m-auto px-0 sm:px-6">
            <div className="rounded-2xl bg-gray-50 border border-gray-200 px-4 py-10">
              <div
                className="text-center mb-10"
                dangerouslySetInnerHTML={{
                  __html: processContent(data?.bloque16),
                }}
              />

              <div className="max-w-4xl m-auto">
                <Accordion
                  title="Redes sobre oferta académica"
                  content={
                    <>
                      <div
                        className="img-contacto   [&_img]:w-10 [&_a]:inline-flex [&_a]:grayscale [&_img]:opacity-70 mb-6"
                        dangerouslySetInnerHTML={{
                          __html: processContent(data?.bloque17),
                        }}
                      />
                    </>
                  }
                ></Accordion>
                <Accordion
                  title="Redes sobre acciones universitarias"
                  content={
                    <>
                      <div
                        className="img-contacto  [&_img]:w-10 [&_a]:inline-flex [&_a]:grayscale [&_img]:opacity-70 mb-6"
                        dangerouslySetInnerHTML={{
                          __html: processContent(data?.bloque18),
                        }}
                      />
                    </>
                  }
                ></Accordion>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome2>
  );
}

export default Contacto;
